// DraggableWindow.js
// Below this the window is part of the document flow, not a floating window,
// so there is nothing to drag. Matches the breakpoint in main.css.
const $18b7f82f1d33c7d2$var$FLOATING = "(min-width: 45rem)";
// However far it is thrown, this much of the window stays on screen — enough
// to grab the title bar and pull it back.
const $18b7f82f1d33c7d2$var$KEEP_VISIBLE = 48;
const $18b7f82f1d33c7d2$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
class $18b7f82f1d33c7d2$export$f738c0a4c7290bc3 {
    constructor(element){
        this.element = element;
        this.handle = element.querySelector(".window-top") || element;
        this.floating = window.matchMedia($18b7f82f1d33c7d2$var$FLOATING);
        this.pointerId = null;
        this.grip = null;
        this.pinned = false;
        this.handle.addEventListener("pointerdown", this.pointerDown.bind(this));
        this.handle.addEventListener("pointermove", this.pointerMove.bind(this));
        this.handle.addEventListener("pointerup", this.pointerUp.bind(this));
        this.handle.addEventListener("pointercancel", this.pointerUp.bind(this));
        this.floating.addEventListener("change", this.layoutChanged.bind(this));
    }
    pointerDown(e) {
        if (!this.floating.matches || e.button !== 0) return;
        // Stops the drag from selecting the title bar's text along the way.
        e.preventDefault();
        this.pin();
        const rect = this.element.getBoundingClientRect();
        this.grip = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        };
        this.pointerId = e.pointerId;
        this.element.classList.add("is-dragging");
        // Capture keeps the events coming to the bar even when the cursor outruns
        // it — the old mousemove-on-document version dropped the window instead.
        this.handle.setPointerCapture?.(e.pointerId);
    }
    pointerMove(e) {
        if (this.pointerId === null || e.pointerId !== this.pointerId) return;
        const { width: width, height: height } = this.element.getBoundingClientRect();
        const left = $18b7f82f1d33c7d2$var$clamp(e.clientX - this.grip.x, $18b7f82f1d33c7d2$var$KEEP_VISIBLE - width, window.innerWidth - $18b7f82f1d33c7d2$var$KEEP_VISIBLE);
        const top = $18b7f82f1d33c7d2$var$clamp(e.clientY - this.grip.y, 0, window.innerHeight - $18b7f82f1d33c7d2$var$KEEP_VISIBLE);
        this.element.style.left = `${left}px`;
        this.element.style.top = `${top}px`;
    }
    pointerUp(e) {
        if (this.pointerId === null || e.pointerId !== this.pointerId) return;
        this.handle.releasePointerCapture?.(this.pointerId);
        this.pointerId = null;
        this.grip = null;
        this.element.classList.remove("is-dragging");
    }
    // The window is centred with `translate(-50%, -50%)`, which dragging would
    // have to keep compensating for. Convert that to real coordinates once, on
    // the first grab, and from then on left/top are the whole truth.
    pin() {
        if (this.pinned) return;
        const rect = this.element.getBoundingClientRect();
        this.element.style.transform = "none";
        this.element.style.left = `${rect.left}px`;
        this.element.style.top = `${rect.top}px`;
        this.pinned = true;
    }
    // Dropping below the breakpoint hands layout back to the stylesheet, so the
    // coordinates from a previous drag have to go with it.
    layoutChanged() {
        if (this.floating.matches || !this.pinned) return;
        this.element.style.transform = "";
        this.element.style.left = "";
        this.element.style.top = "";
        this.pinned = false;
    }
}


// windowContentLoader.js
const $f064ffc6c2321b02$var$FLOPPY = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
█░▐███TIM███▌░█
█░▐MONKEY2██▌░█
█░▐███1994██▌░█
█░░░░░░░░░░░░░█
█░▄▄▄▄▄▄▄▄░░░░█
█░█░░░░░░█░░░░█
█░█░░░░░░█░░░░█
▀▄█▄▄▄▄▄▄█▄▄▄▄█`;
const $f064ffc6c2321b02$var$ENVELOPE = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
█▄▄░░░░░░░░░░░░▄▄█
█░░▀▀▄▄░░░░▄▄▀▀░░█
█░░░░░░▀▄▄▀░░░░░░█
█░░░░░░░░░░░░░░░░█
▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀`;
// A Game Boy cartridge, for the buffer that opens with an emulator.
const $f064ffc6c2321b02$var$CARTRIDGE = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
█▀▀▀▀▀▀▀▀▀▀▀▀▀█
█░▄▄▄▄▄▄▄▄▄▄▄░█
█░▐█TETRIS██▌░█
█░▐███1989██▌░█
█░▀▀▀▀▀▀▀▀▀▀▀░█
█░░░░░░░░░░░░░█
█░░░░░░░░░░░░▄▀
▀▀▀▀▀▀▀▀▀▀▀▀▀▀`;
const $f064ffc6c2321b02$export$55fd7ad1e6de798f = {
    "README.txt": $f064ffc6c2321b02$var$FLOPPY,
    "projects.html": $f064ffc6c2321b02$var$CARTRIDGE,
    "contact.html": $f064ffc6c2321b02$var$ENVELOPE
};


class $59512b6270ebb58a$export$d23cc7b261fec69b {
    constructor(){
        this.element = document.querySelector(".window-content");
        this.title = document.querySelector(".window-top .title");
        this.pathLabel = document.querySelector(".window-shell .path");
        this.countLabel = document.querySelector(".window-shell .count");
        this.wallpaper = document.querySelector(".wallpaper");
        this.window = document.querySelector("#mainWindow");
    }
    // `label` is what the window calls the buffer, which is not always what it
    // fetched: the bio is authored as README.html so an editor treats it as HTML,
    // and shown as README.txt because that is the joke.
    async loadContent(path, label = path) {
        try {
            const response = await fetch(path);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const html = await response.text();
            this.element.innerHTML = html;
            // The title is rendered from this: VimMode appends [+] to it.
            this.title.dataset.buffer = label;
            this.title.textContent = `\u{25A0} ${label}`;
            this.pathLabel.textContent = `"home.hal9.xyz/${label}"`;
            this.countLabel.textContent = this.describe(html);
            this.wallpaper.textContent = (0, $f064ffc6c2321b02$export$55fd7ad1e6de798f)[label] ?? "";
            // Opening a buffer brings the window back, which is the only way back
            // from `:q!` short of a reload.
            this.window?.classList.remove("is-closed");
        } catch (error) {
        //console.error('Error loading content:', error);
        }
    }
    // What vim prints when it opens a file. Measured from the body we were
    // handed rather than read off Content-Length: nginx gzips HTML, and a gzipped
    // response carries no Content-Length at all — which is why this line used to
    // say "nullB" in a browser while the tests, with their mocked header, passed.
    describe(html) {
        const lines = html.split("\n").length;
        const bytes = new TextEncoder().encode(html).length;
        return `${lines}L, ${bytes}B`;
    }
}


// CollapsibleManager.js
class $9a7cbf6d40b1a167$export$738a1a0b3e9c3312 {
    constructor(selector){
        this.collapsibles = document.querySelectorAll(selector);
        this.initialize();
    }
    initialize() {
        for(let i = 0; i < this.collapsibles.length; i++)this.collapsibles[i].addEventListener("click", function() {
            this.classList.toggle("active");
            const content = this.nextElementSibling;
            if (content.style.display === "block") content.style.display = "none";
            else content.style.display = "block";
        });
    }
}


// VimMode.js
//
// The page already looks like vim, so it may as well answer to it. Press `i`
// to edit the buffer, `:` to open the command line. Nothing here persists: `:w`
// exists to say so.
const $aebf846cf08273c8$var$MESSAGES = {
    noWrite: "E37: No write since last change (add ! to override)",
    readonly: "E212: Can't open file for writing: Permission denied (are you root?)",
    notCommand: (cmd)=>`E492: Not an editor command: ${cmd}`,
    noFile: (name)=>`E484: Can't open file ${name}`
};
// `i` should reach a link or a button the visitor is tabbing through rather
// than opening the editor under their feet.
const $aebf846cf08273c8$var$INTERACTIVE = "a, button";
class $aebf846cf08273c8$export$b6b36e67aa57a016 {
    constructor({ element: element, buffers: buffers = {} }){
        this.element = element;
        this.content = element.querySelector(".window-content");
        this.title = element.querySelector(".window-top .title");
        this.file = element.querySelector(".window-shell .file");
        this.modeChip = element.querySelector(".window-shell .mode");
        this.cmdline = element.querySelector(".window-shell .cmdline");
        this.buffers = buffers;
        this.mode = "normal";
        this.command = "";
        this.modified = false;
        this.content.addEventListener("input", ()=>{
            this.modified = true;
            this.renderTitle();
        });
        document.addEventListener("keydown", this.keyDown.bind(this));
    }
    keyDown(e) {
        // Leave the browser's own shortcuts alone.
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (this.mode === "insert") {
            if (e.key === "Escape") {
                e.preventDefault();
                this.toNormal();
            }
            return; // everything else is typing
        }
        if (this.mode === "command") {
            this.commandKey(e);
            return;
        }
        if (this.isClosed()) return;
        if (e.key === "i" && !this.onInteractive()) {
            e.preventDefault();
            this.toInsert();
            return;
        }
        if (e.key === ":") {
            e.preventDefault();
            this.toCommand();
        }
    }
    commandKey(e) {
        if (e.key === "Escape") {
            e.preventDefault();
            this.toNormal();
            return;
        }
        if (e.key === "Enter") {
            e.preventDefault();
            this.run(this.command.trim());
            return;
        }
        if (e.key === "Backspace") {
            e.preventDefault();
            // Backspacing past the colon leaves the command line, as it does in vim.
            if (this.command === "") this.toNormal();
            else {
                this.command = this.command.slice(0, -1);
                this.renderCommand();
            }
            return;
        }
        if (e.key.length === 1) {
            e.preventDefault();
            this.command += e.key;
            this.renderCommand();
        }
    }
    run(command) {
        if (command === "") {
            this.toNormal();
            return;
        }
        if (command === "q") {
            // Always, even on an untouched buffer: the point is the joke, and :q!
            // is right there.
            this.message($aebf846cf08273c8$var$MESSAGES.noWrite);
            return;
        }
        if (command === "q!") {
            this.quit();
            return;
        }
        if (command === "w" || command === "wq" || command === "x") {
            this.message($aebf846cf08273c8$var$MESSAGES.readonly);
            return;
        }
        const edit = command.match(/^e!?\s+(\S+)$/);
        if (edit) {
            this.edit(edit[1]);
            return;
        }
        this.message($aebf846cf08273c8$var$MESSAGES.notCommand(command));
    }
    edit(name) {
        // `:e README`, `:e README.txt` and `:e readme` all mean the same buffer.
        const key = name.toLowerCase().replace(/\.[^.]+$/, "");
        const buffer = this.buffers[key];
        if (!buffer) {
            this.message($aebf846cf08273c8$var$MESSAGES.noFile(name));
            return;
        }
        this.toNormal();
        this.modified = false;
        buffer();
    }
    quit() {
        this.toNormal();
        this.element.classList.add("is-closed");
    }
    toInsert() {
        this.mode = "insert";
        this.editable(true);
        this.render();
    }
    toNormal() {
        this.mode = "normal";
        this.command = "";
        this.editable(false);
        this.render();
    }
    toCommand() {
        this.mode = "command";
        this.command = "";
        this.render();
    }
    message(text) {
        this.mode = "normal";
        this.command = "";
        this.editable(false);
        this.render();
        this.cmdline.textContent = text;
        this.cmdline.classList.add("is-error");
        this.cmdline.hidden = false;
        this.file.hidden = true;
    }
    render() {
        this.cmdline.classList.remove("is-error");
        this.renderTitle();
        if (this.mode === "command") {
            this.renderCommand();
            return;
        }
        this.cmdline.hidden = true;
        this.file.hidden = false;
        this.modeChip.hidden = false;
        this.modeChip.textContent = this.mode === "insert" ? "-- INSERT --" : "-- NORMAL --";
    }
    renderCommand() {
        this.cmdline.textContent = `:${this.command}`;
        this.cmdline.hidden = false;
        this.file.hidden = true;
        this.modeChip.hidden = true;
    }
    renderTitle() {
        const buffer = this.title.dataset.buffer;
        if (buffer) this.title.textContent = `\u{25A0} ${buffer}${this.modified ? " [+]" : ""}`;
    }
    // Leaving insert has to hand the focus back as well as the attribute:
    // a still-focused content area keeps the :focus-visible ring, which the
    // window then clips into a stray line down its edge.
    editable(on) {
        this.content.setAttribute("contenteditable", on ? "true" : "false");
        if (on) this.content.focus();
        else this.content.blur();
    }
    isClosed() {
        return this.element.classList.contains("is-closed");
    }
    onInteractive() {
        const focused = document.activeElement;
        return Boolean(focused && focused.matches && focused.matches($aebf846cf08273c8$var$INTERACTIVE));
    }
}


// CursorPosition.js
//
// The line,col and Top/Bot indicator in the title bar, kept honest.
//
// A rendered page has no file lines, so "line" here is the block the cursor is
// in — a paragraph, a heading, a list item — counted in document order, and
// "col" is the characters into that block. While you are editing, both follow
// the caret; the rest of the time they follow whatever is scrolled into view,
// since that is the closest thing to where you are looking.
const $69ad2f2575d975ca$var$BLOCKS = "p, h2, h3, h4, li, pre";
class $69ad2f2575d975ca$export$22a7cc4f4dfb3f72 {
    constructor(element){
        this.content = element.querySelector(".window-content");
        this.pos = element.querySelector(".window-top .pos");
        this.content.addEventListener("scroll", ()=>this.render());
        this.content.addEventListener("input", ()=>this.render());
        document.addEventListener("selectionchange", ()=>this.render());
        // The buffer is replaced wholesale when another one is opened.
        new MutationObserver(()=>this.render()).observe(this.content, {
            childList: true
        });
        this.render();
    }
    render() {
        const [line, column] = this.caret() ?? this.firstVisible();
        this.pos.textContent = `${line},${column}\xa0\xa0\xa0${this.scrolled()}`;
    }
    blocks() {
        return [
            ...this.content.querySelectorAll($69ad2f2575d975ca$var$BLOCKS)
        ];
    }
    // Where the caret is, or null when it is somewhere else on the page.
    caret() {
        const selection = document.getSelection();
        if (!selection || selection.rangeCount === 0 || !selection.anchorNode) return null;
        const node = selection.anchorNode;
        if (!this.content.contains(node)) return null;
        const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
        const block = element.closest($69ad2f2575d975ca$var$BLOCKS);
        const blocks = this.blocks();
        if (!block || !blocks.includes(block)) return null;
        const upToCaret = document.createRange();
        upToCaret.selectNodeContents(block);
        upToCaret.setEnd(node, selection.anchorOffset);
        return [
            blocks.indexOf(block) + 1,
            upToCaret.toString().length + 1
        ];
    }
    firstVisible() {
        const blocks = this.blocks();
        const top = this.content.scrollTop;
        const index = blocks.findIndex((block)=>block.offsetTop + block.offsetHeight > top);
        return [
            index === -1 ? 1 : index + 1,
            1
        ];
    }
    scrolled() {
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = this.content;
        const hidden = scrollHeight - clientHeight;
        if (hidden <= 0) return "All";
        if (scrollTop <= 0) return "Top";
        if (scrollTop >= hidden - 1) return "Bot";
        return `${Math.round(scrollTop / hidden * 100)}%`;
    }
}


// ThemeToggle.js
//
// The gear in the menu bar. Dark is the design's home, and the light palette is
// the same one turned over — see main.css. Until the gear is touched the page
// follows the visitor's system preference; after that their choice sticks.
const $a46e319415c7b0ab$var$STORAGE_KEY = "theme";
class $a46e319415c7b0ab$export$173e0a822059eddc {
    constructor(button){
        this.button = button;
        this.root = document.documentElement;
        const stored = this.read();
        if (stored) this.root.dataset.theme = stored;
        this.reflect();
        this.button.addEventListener("click", ()=>{
            this.apply(this.isLight() ? "dark" : "light");
        });
    }
    apply(theme) {
        this.root.dataset.theme = theme;
        this.write(theme);
        this.reflect();
    }
    isLight() {
        const chosen = this.root.dataset.theme;
        if (chosen) return chosen === "light";
        return Boolean(window.matchMedia?.("(prefers-color-scheme: light)").matches);
    }
    // The label carries the state, spelled the way vim spells it. It is set in
    // the page's own face rather than an icon font or an emoji, so it looks the
    // same on every system.
    reflect() {
        const light = this.isLight();
        this.button.textContent = `bg=${light ? "light" : "dark"}`;
        this.button.setAttribute("aria-pressed", String(light));
    }
    // Private browsing and blocked site data both throw here, and a theme is not
    // worth taking the page down for.
    read() {
        try {
            return localStorage.getItem($a46e319415c7b0ab$var$STORAGE_KEY);
        } catch (error) {
            return null;
        }
    }
    write(theme) {
        try {
            localStorage.setItem($a46e319415c7b0ab$var$STORAGE_KEY, theme);
        } catch (error) {
        // the choice lasts for this visit only
        }
    }
}


document.addEventListener('DOMContentLoaded', function() {
    const contentLoader = new (0, $59512b6270ebb58a$export$d23cc7b261fec69b)();
    new (0, $18b7f82f1d33c7d2$export$f738c0a4c7290bc3)(document.querySelector('#mainWindow'));
    const readmeButton = document.querySelector('#load-readme');
    const projectsButton = document.querySelector('#load-projects');
    const contactButton = document.querySelector('#load-contact');
    // Which buffer is open, shown the way a file manager shows it: the entry
    // stays highlighted.
    function markActive(button) {
        [
            readmeButton,
            projectsButton,
            contactButton
        ].forEach((candidate)=>{
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            if (active) candidate.setAttribute('aria-current', 'true');
            else candidate.removeAttribute('aria-current');
        });
    }
    function loadReadme() {
        markActive(readmeButton);
        contentLoader.loadContent('README.html', 'README.txt').then(()=>{
            new (0, $9a7cbf6d40b1a167$export$738a1a0b3e9c3312)('.collapsible');
        });
    }
    function loadProjects() {
        markActive(projectsButton);
        contentLoader.loadContent('projects.html');
    }
    function loadContact() {
        markActive(contactButton);
        contentLoader.loadContent('contact.html');
    }
    new (0, $a46e319415c7b0ab$export$173e0a822059eddc)(document.querySelector('#toggle-theme'));
    new (0, $69ad2f2575d975ca$export$22a7cc4f4dfb3f72)(document.querySelector('#mainWindow'));
    new (0, $aebf846cf08273c8$export$b6b36e67aa57a016)({
        element: document.querySelector('#mainWindow'),
        buffers: {
            readme: loadReadme,
            projects: loadProjects,
            contact: loadContact
        }
    });
    readmeButton.addEventListener('click', loadReadme);
    projectsButton.addEventListener('click', loadProjects);
    contactButton.addEventListener('click', loadContact);
    loadReadme(); // Hi! :)
}, false);


//# sourceMappingURL=web.e26ab5ed.js.map
